import * as GestureHandler from 'react-native-gesture-handler';
export default GestureHandler;
